import { useParams } from 'react-router-dom'
import eyeOnIcon from '../../../../assests/learning-tracking/lesson/eyeOnIcon.png'
import eyeOnIconBold from '../../../../assests/learning-tracking/lesson/eyeOnIconBold.png'
import fileTextIcon from '../../../../assests/learning-tracking/lesson/fileTextIcon.png'
import fileTextIconBold from '../../../../assests/learning-tracking/lesson/fileTextIconBold.png'
import classes from './Lesson.module.css'

import LessonViewer from "../../../lms-shared/LessonViewer/LessonViewer"
import { useEffect, useState } from 'react'
import LessonPlanView from '../../Lesson/LessonPlanView'
import { lessonsApi } from '../../../../utils'
import { useDispatch, useSelector } from 'react-redux'
import { throwApiError } from '../../../lms-shared/store/error-handling-actions'
import { lessonActions } from '../../../../store/lesson-slice'
import { onKeyDown } from '../../../../service'

const Lesson = ({ backUrl, showCloseIcon }) => {

    const { guid, id } = useParams()
    const [content, setContent] = useState("viewer");
    const [lessonData, setLessonData] = useState({});
    const texts = useSelector(state => state.translate.texts);
    const { lesson } = useSelector(state => state.lessons);
    const dispatch = useDispatch()

    const contentTypes = {
        viewer: LessonViewer,
        plan: LessonPlanView
    }
    const handleClick = (type) => {
        setContent(type)
    }

    useEffect(() => {
        if (guid && guid !== "0") {
            if (lesson?.id !== guid) {
                const data = {
                    id: guid
                }

                lessonsApi.lessonsFilterPost({ lessonFilter: data }, (error, resdata, response) => {
                    if (error) {
                        dispatch(throwApiError({ userMessage: texts.lessonsFilterError, error: error, statusCode: response?.statusCode, message: "lessonsFilterPost " + error.message, level: 2, component: "", line: 41 }))
                        setLessonData(null)
                    }
                    else {
                        const newbody = response.body
                        if (response.body.contentData) {
                            const newAdditionalData = JSON.parse(newbody.contentData)
                            newbody.contentData = newAdditionalData
                        }
                        setLessonData({ ...newbody });
                        dispatch(lessonActions.setLesson({ lesson: newbody }));
                    }
                })
            }
            else {
                setLessonData(lesson);
            }
        }
        else {
            setLessonData(null)
        }
    }, [guid])
    return (
        <div className={classes.ViewLessons}>
            <div className={classes.MenuContainer}>
                <p className={`${classes.MenuBtn} ${"viewer" === content && classes.Selected}`} onClick={() => handleClick("viewer")} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleClick("viewer"))}>
                    {texts.viewLesson}
                    <img src={"viewer" === content ? eyeOnIconBold : eyeOnIcon} alt={eyeOnIcon} />
                </p>
                <div className={classes.Line} ></div>
                <p className={`${classes.MenuBtn} ${"plan" === content && classes.Selected}`} onClick={() => handleClick("plan")} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => handleClick("plan"))}>
                    {texts.Lesson}
                    <img src={"plan" === content ? fileTextIconBold : fileTextIcon} alt={fileTextIcon} />
                </p>
            </div>
            <div className={classes.WrapLessonViewer}>
                {
                    (() => {
                        if (lessonData) {
                            if (lessonData.activeFromDate && new Date(lessonData.activeFromDate) > new Date() || lessonData.hasOwnProperty('activeFromDate') && !lessonData.activeFromDate && !lessonData.active) {
                                return <div className={classes.lessonLocked}>{texts.lessonLocked}</div>
                            }
                            else {
                                const Compnent = contentTypes[content];
                                return Compnent && <Compnent backUrl={backUrl} showCloseIcon={showCloseIcon} {...lessonData} teacherMode={true} lessonId={guid} studyGroupId={id}></Compnent>
                            }

                        }
                    })()
                }
            </div>
        </div>
    )
}
export default Lesson